<template>
  <div id="content-wrapper">
    <b-form-group class="border-bottom-form">
      <div class="row justify-content-space-between m-0">
        <div class="col-xl-5 col-lg-6 p-0">
          <div class="d-flex align-items-center">
            <div class="font-weight-bold">Tên đơn vị</div>
            <div class="d-flex flex-1-0 ml-2">
              <v-select
                :options="danhSachDonViSelect"
                :reduce="(text) => text.value"
                label="text"
                v-model="searchForm.donVi"
                @input="layDanhSachCanBoPhanTrang(true)"
                v-if="false"
              >
              </v-select>
              <treeselect
                v-else
                :load-options="loadOptionsDonVi"
                :clearable="true"
                :normalizer="normalizer"
                :options="danhSachDonViBanDau || []"
                :show-count="true"
                :value="searchForm.donVi"
                no-children-text="Không có đơn vị con"
                placeholder="Chọn đơn vị"
                ref="chonCayDonVi"
                v-model="searchForm.donVi"
                @input="layDanhSachCanBoPhanTrang(true)"
              >
                <label
                  :class="labelClassName"
                  slot="option-label"
                  slot-scope="{
                    node,
                    shouldShowCount,
                    count,
                    labelClassName,
                    countClassName,
                  }"
                >
                  {{ node.label }}
                  <span
                    :class="countClassName"
                    v-if="shouldShowCount && count > 0"
                    >({{ count }})</span
                  >
                </label>
              </treeselect>
            </div>
            <b-form-checkbox
              class="ml-3"
              v-model="isGetAll"
              @change="onChangeGetAll"
            >
              Tất cả
            </b-form-checkbox>
          </div>
        </div>
        <div class="">
          <base-button
            button="Import"
            @click="openImport"
            variant="info"
            class="btn btn-green"
            v-if="hasPermissionUser(PERMISSION_NAME.IMPORT.IMPORT_CAN_BO)"
          >
            Import
          </base-button>
          <base-button
            class="btn btn-blue"
            @click="openExport(false)"
            :disabled="isLoadingExport"
            variant="info"
            v-if="hasPermissionUser(PERMISSION_NAME.IMPORT.EXPORT_CAN_BO)"
            button="Export"
          >
          </base-button>
          <base-button
            class="btn btn-blue"
            @click="openExport(true)"
            :disabled="isLoadingExportUser || !searchForm.donVi"
            variant="info"
            v-if="hasPermissionUser(PERMISSION_NAME.IMPORT.EXPORT_CAN_BO)"
            button="Export thông tin in thẻ"
          >
          </base-button>
          <base-button
            button="Thêm mới"
            @click="openCreate"
            variant="info"
            class="btn btn-green float-right"
            v-if="hasPermissionUser(PERMISSION_NAME.CAN_BO.THEM)"
          >
            Thêm mới
          </base-button>
        </div>
      </div>
    </b-form-group>
    <form>
      <div class="box-form-result">
        <p class="color-gray-1">
          Tìm thấy {{ danhSachCanBo.totalCount }} kết quả
        </p>
        <DataTable
          :value="danhSach || []"
          class="p-datatable-customers mt-2"
          dataKey="Id"
          :paginator="false"
          :auto-layout="true"
          :loading="isLoadingTable"
          :key="danhSachCanBo.length"
        >
          <template #empty
            ><div class="text-center">Không có dữ liệu</div></template
          >
          <template #loading>Đang tải dữ liệu ...</template>
          <Column
            v-for="(col, index) in fieldDisplay"
            :key="index"
            :field="col.field"
            :header="col.header"
            :header-class="col.headerClass"
            :header-style="col.headerStyle"
            :body-class="col.bodyClass"
          >
            <template #filter>
              <InputText
                v-if="col.keySearch"
                type="text"
                class="p-column-filter"
                placeholder="Tìm kiếm"
                v-model="form[col.keySearch]"
                @keyup.enter="layDanhSachCanBoPhanTrang(true)"
              />
            </template>
            <template v-if="col.field === 'stt'" #body="slotProps">
              <div class="text-center">{{ slotProps.index + 1 }}</div>
            </template>
            <template v-else-if="col.field === 'hoTen'" #body="slotProps">
              <a
                :href="`${ROUTE.QUAN_LY_DANH_MUC.NAME}${
                  idDonViCha == 1
                    ? ROUTE.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.NAME
                    : ROUTE.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.XEM_THUOC_DON_VI_NAME
                }/${slotProps.data.id}`"
              >
                {{ slotProps.data.hoTen }}
              </a>
            </template>
            <template
              v-else-if="col.field === 'anhDaiDien_FilePath'"
              #body="slotProps"
            >
              <div class="text-center">
                <img v-if="slotProps.data.anhDaiDien_FilePath && slotProps.data.anhDaiDien_FilePath.includes('data:image')" :src="slotProps.data.anhDaiDien_FilePath" style="width: 50px" height="auto"/>
                <b-avatar
                  v-else
                  :src="slotProps.data.anhDaiDien_FilePath"
                  rounded
                  size="lg"
                ></b-avatar>
              </div>
            </template>
            <template v-else-if="col.field === 'userName'" #body="slotProps">
              <div
                v-for="(item, index) in slotProps.data.userName"
                :key="index"
              >
                - {{ item }}
              </div>
            </template>
            <template v-else-if="col.field === 'chucVu'" #body="slotProps">
              <div v-for="(item, index) in slotProps.data.chucVu" :key="index">
                - {{ item }}
              </div>
            </template>
            <template v-else-if="col.field === 'donVi'" #body="slotProps">
              <div v-for="(item, index) in slotProps.data.recurisveTenDonVi" :key="index">
                - {{ item }}
              </div>
            </template>
            <template v-else-if="col.field === 'trangThai'" #body="slotProps">
              <div class="text-center">
                <b-form-checkbox
                  class="text-center cursor-pointer"
                  :checked="slotProps.data.LockoutEnabled"
                  switch
                  v-model="slotProps.data.LockoutEnabled"
                  @change="handleChangeTrangThai(slotProps.data)"
                ></b-form-checkbox>
              </div>
            </template>
            <template v-else-if="col.field === 'thaoTac'" #body="slotProps">
              <div class="text-center">
                <font-awesome-icon
                  icon="edit"
                  v-if="hasPermissionUser(PERMISSION_NAME.CAN_BO.SUA)"
                  v-b-popover.hover.top="'Cập nhật cán bộ'"
                  class="cursor-pointer color-red ml-2"
                  @click="openEdit(slotProps.data)"
                />
                <font-awesome-icon
                  icon="trash-alt"
                  v-if="hasPermissionUser(PERMISSION_NAME.CAN_BO.XOA)"
                  v-b-popover.hover.top="'Xóa cán bộ'"
                  class="cursor-pointer color-red ml-2"
                  @click="openDelete(slotProps.data)"
                />
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
      <BasePagination
        :current-page="danhSachCanBo.pageIndex"
        :total-pages="danhSachCanBo.totalPage"
        :total-rows="danhSachCanBo.totalCount"
        @changeNum="onChangeNum($event)"
        @changePages="onChangePages($event)"
      />
    </form>
    <ModalConfirm :title="canBoDaChon.hoTen" @confirmed="xoaCanBo" />
    <ModalUploadImportFile
      ref="modalImport"
      :dataType="'CanBo'"
      :title="'Cán bộ/User'"
      @refreshData="layDanhSachCanBoPhanTrang(true)"
    />
  </div>
</template>

<script>
import ModalUploadImportFile from "@/components/modal/ModalUploadImportFile";
import BasePagination from "@/components/common/BasePagination";
import ModalConfirm from "@/components/modal/ModalConfirm";
import { mapGetters } from "vuex";
import { ROUTE_NAME, PERMISSION_NAME } from "@/constants/constants";
import { LOAD_CHILDREN_OPTIONS, Treeselect } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { hasPermissionUser } from "@/utils/permissionUtils";
import { CAP_NHAT_ACTIVE_NGUOI_DUNG } from "@/constants/message";

// import moment from "moment";
import _isEmpty from "lodash/isEmpty";
export default {
  name: "DanhSachCanBo",
  components: {
    BasePagination,
    ModalConfirm,
    Treeselect,
    ModalUploadImportFile
  },
  props: {
    idDonViCha: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      danhSach: null,
      isLoadingExport: false,
      isLoadingExportUser: false,
      PERMISSION_NAME,
      isGetAll: true,
      ROUTE: ROUTE_NAME,
      searchForm: {
        keyword: "",
        donVi: this.idDonViCha || null
      },
      form: {
        hoTen: "",
        userName: "",
        maCanBo: "",
        chucVu: "",
        donVi: "",
        email: ""
      },
      hoSoDaChon: null,
      isEdit: false,
      optionsDonVi: [],
      fieldDisplay: [],
      canBoDaChon: {},
      optionsDonViBietPhai: [],
      fieldNames: [
        {
          field: "stt",
          header: "STT",
          headerStyle: "width: 30px",
          formatter: () => {
            return (
              (this.danhSachCanBo.pageIndex - 1) * this.danhSachCanBo.pageSize +
              1
            );
          }
        },
        {
          field: "anhDaiDien_FilePath",
          header: "Ảnh đại diện",
          headerStyle: "width: 85px",
          class: "fit-column center"
        },
        {
          field: "hoTen",
          keySearch: "HoTenFilter",
          header: "Họ tên cán bộ"
        },
        {
          field: "userName",
          keySearch: "UserNameFilter",
          header: "Tên đăng nhập"
        },
        {
          field: "maCanBo",
          keySearch: "MaCanBoFilter",
          header: "Mã cán bộ",
          class: "fit-column "
        },
        {
          field: "chucVu",
          keySearch: "ChucVuFilter",
          headerStyle: "width: 200px",
          header: "Chức vụ",
          class: "fit-column"
        },
        {
          field: "donVi",
          keySearch: "DonViFilter",
          headerStyle: "width: 200px",
          header: "Đơn Vị"
        },
        {
          field: "email",
          keySearch: "EmailFilter",
          header: "Email"
        },
        {
          field: "trangThai",
          header: "Trạng thái"
        },
        {
          field: "thaoTac",
          header: "Thao tác",
          headerStyle: "width: 90px",
          class: "center fit-column"
        }
      ],
      isLoadingTable: false
    };
  },
  computed: {
    ...mapGetters({
      chiTietCanBo: "canBo/canBo",
      danhSachCanBo: "canBo/danhSachCanBo",
      danhSachDonViSelect: "donVi/danhSachDonViSelect",
      danhSachDonViCon: "donVi/danhSachDonViCon",
      danhSachDonVi: "donVi/danhSachDonVi"
    }),
    danhSachDonViBanDau() {
      if (!this.danhSachDonVi) {
        return [];
      }
      let danhSach = [];
      danhSach = this.danhSachDonVi.map(item => {
        return {
          Task_ID: item.id,
          Task_Parent_ID: item.iD_DonVi_Cha,
          Label: item.tenDonVi,
          Childrens: [],
          ...item
        };
      });
      return this.list_to_tree(danhSach);
    }
  },
  created() {
    this.layDanhSachCanBoPhanTrang();
    this.fieldDisplay = this.fieldNames.map(item => {
      let itemMap = {
        key: item.key,
        label: item.label,
        ...item,
        display: true
      };
      if (itemMap.field === "thaoTac") {
        if (
          this.hasPermissionUser(this.PERMISSION_NAME.CAN_BO.SUA) &&
          this.hasPermissionUser(this.PERMISSION_NAME.CAN_BO.XOA)
        ) {
          itemMap.display = true;
        } else {
          itemMap.display = false;
          itemMap.headerClass = "d-none";
          itemMap.bodyClass = "d-none";
        }
      }
      return itemMap;
    });
    this.$store.dispatch("donVi/layDanhSachDonViCha", {}).then(() => {});
  },
  methods: {
    hasPermissionUser,
    handleChangeTrangThai(item) {
      const payload = {
        id: item.id,
        LockoutEnabled: !item.LockoutEnabled
      };
      this.$store.dispatch("donVi/updateSetLock", payload).then(res => {
        if (res.data.succeeded) {
          this.$toasted.clear();
          this.$toasted.global.showSuccessMessage({
            message: CAP_NHAT_ACTIVE_NGUOI_DUNG
          });
        }
      });
    },
    openImport() {
      this.$refs["modalImport"].showModal();
    },
    openExport(isExportInThe) {
      let typeExport = "CanBo";
      isExportInThe ? this.isLoadingExportUser = true :  this.isLoadingExport = true
      let payload = {
        PageIndex: this.danhSachCanBo.pageIndex,
        PageSize: this.danhSachCanBo.pageSize,
        IsGetAll: this.isGetAll,
        SortBy: "ThuTu asc",
        ...this.form
      };

      if (this.searchForm.keyword) {
        payload = Object.assign(payload, { FilterBy: this.searchForm.keyword });
      }
      if (this.searchForm.donVi) {
        payload = Object.assign(payload, { ID_DonVi: this.searchForm.donVi });
      }
      this.$store
        .dispatch('importService/exportData', {
          type: isExportInThe ? 'InThe' : typeExport,
          searchRequest: payload
        })
        .then(res => {
          isExportInThe ? this.isLoadingExportUser = false :  this.isLoadingExport = false
          this.$toasted.global.showSuccessMessage({
            message: "Export thành công"
          });
          let url = window.URL.createObjectURL(new Blob([res.data]));
          let link = document.createElement("a");
          link.href = url;
          link.setAttribute("download",  `Export${typeExport}.${isExportInThe ? 'zip' : 'xlsx'}`);
          document.body.appendChild(link);
          link.click();
        });
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    treeselectClass(valid) {
      return {
        "treeselect-invalid": valid
      };
    },
    normalizer(node) {
      return {
        children: _isEmpty(node.children) ? undefined : node.children
      };
    },
    list_to_tree(list) {
      if (list.length > 0) {
        var map = {},
          node,
          roots = [],
          i;
        for (i = 0; i < list.length; i += 1) {
          map[list[i].Task_ID] = i; // initialize the map
          list[i].Childrens = []; // initialize the children
        }
        for (i = 0; i < list.length; i += 1) {
          node = list[i];
          if (node.Task_Parent_ID !== this.guidEmpty) {
            // if you have dangling branches check that map[node.parentId] exists
            if (list[map[node.Task_Parent_ID]] != null) {
              list[map[node.Task_Parent_ID]].Childrens.push({
                id: node.Task_ID,
                label: node.Label,
                parentId: node.Task_Parent_ID,
                children: node.Childrens
              });
            } else {
              roots.push({
                id: node.Task_ID,
                label: node.Label,
                parentId: node.Task_Parent_ID,
                children: node.Childrens
              });
            }
          } else {
            roots.push({
              id: node.Task_ID,
              label: node.Label,
              parentId: node.Task_Parent_ID,
              children: node.Childrens
            });
          }
        }
        return roots;
      }
      return list;
    },
    onChangeGetAll() {
      this.$nextTick(() => {
        this.layDanhSachCanBoPhanTrang(true);
      });
    },
    loadOptionsDonVi({ action, parentNode, callback }) {
      if (action === LOAD_CHILDREN_OPTIONS) {
        this.layDanhSachTheoDonViCha(parentNode.id).then(data => {
          parentNode.children = data;
          callback();
          this.$refs.chonCayDonVi.initialize(this.optionsDonVi);
        });
      }
    },

    onChangeNum(pageSize) {
      this.danhSachCanBo.pageIndex = 1;
      this.danhSachCanBo.pageSize = pageSize;
      this.layDanhSachCanBoPhanTrang();
    },
    onChangePages(page) {
      this.danhSachCanBo.pageIndex = page;
      this.layDanhSachCanBoPhanTrang();
    },
    layDanhSachCanBoPhanTrang(resetPage = false) {
      if (resetPage) this.danhSachCanBo.pageIndex = 1;
      let payload = {
        PageIndex: this.danhSachCanBo.pageIndex,
        PageSize: this.danhSachCanBo.pageSize,
        IsGetAll: this.isGetAll,
        SortBy: "ThuTu asc",
        ...this.form
      };

      if (this.searchForm.keyword) {
        payload = Object.assign(payload, { FilterBy: this.searchForm.keyword });
      }
      if (this.searchForm.donVi) {
        payload = Object.assign(payload, { ID_DonVi: this.searchForm.donVi });
      }
      this.isLoadingTable = true;
      this.$store
        .dispatch("canBo/layDanhSachCanBo", payload)
        .then(res => {
          if (res.data.items && res.data.items.length > 0) {
            res.data.items.forEach(item => {
              if (item.anhDaiDien_FilePath) {
                this.$store
                  .dispatch("canBo/getImageUser", {
                    path: item.anhDaiDien_FilePath
                  })
                  .then(res2 => {
                    item.anhDaiDien_FilePath = this._arrayBufferToBase64(res2);
                  })
                  .catch(() => {
                    item.anhDaiDien_FilePath = null;
                  });
              }
            });
            this.danhSach = res.data.items;
          } else {
            this.danhSach = [];
          }
          this.isLoadingTable = false;
        })
        .catch(() => {
          this.isLoadingTable = false;
        });
    },
    _arrayBufferToBase64(buffer) {
      if (!buffer) {
        return null;
      }
      var binary = "";
      var bytes = new Uint8Array(buffer);
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return `data:image/png;base64,${window.btoa(binary)}`;
    },
    layDanhSachTheoDonViCha(parentId = null) {
      return this.$store
        .dispatch("donVi/layDanhSachTheoDonViCha", {
          idDonViCha: parentId || this.idDonViCha,
          soCap: 999
        })
        .then(response => {
          if (!parentId && this.idDonViCha)
            this.$store.dispatch("donVi/layChiTietDonVi", {
              data: {
                id: this.idDonViCha
              },
              onSuccess: dataResponse => {
                this.optionsDonVi = [
                  {
                    id: this.idDonViCha,
                    tenDonVi: dataResponse.tenDonVi,
                    children: response
                  }
                ];
              }
            });
          else return response;
        });
    },
    toggleDisplay(item) {
      this.fieldNames.forEach((col, index) => {
        if (col.key === item.key) {
          if (item.display) {
            this.fieldNames[index] = Object.assign({}, this.fieldNames[index], {
              class: "d-none"
            });
          } else {
            this.fieldNames[index] = Object.assign({}, this.fieldNames[index], {
              class: ""
            });
          }
        }
      });
      this.$refs.canBoTable.refresh();
    },
    openCreate() {
      this.$router.push({
        name: ROUTE_NAME.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.TAO
      });
    },
    openEdit(item) {
      this.$router.push(
        `${this.ROUTE.QUAN_LY_DANH_MUC.NAME}${
          this.ROUTE.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.NAME
        }/${item.id}/cap-nhat`
      );
    },
    layChiTietCanBo() {
      this.$store.dispatch("canBo/layChiTietCanBo", {
        id: this.hoSoDaChon.id
      });
    },
    layDanhSachChucVu() {
      this.$store.dispatch("chucVu/layDanhSachChucVu");
    },
    successCapNhat() {
      this.layDanhSachCanBoPhanTrang();
    },
    openDelete(item) {
      this.canBoDaChon = item;
      this.$bvModal.show("modal-confirm");
    },
    xoaCanBo(confirm) {
      if (confirm) {
        this.$store.dispatch("canBo/xoaCanBo", {
          data: { id: this.canBoDaChon.id },
          onSuccess: this.onSuccess
        });
        this.$bvModal.hide("modal-confirm");
      }
    },
    onSuccess() {
      this.layDanhSachCanBoPhanTrang(true);
    }
  },
  watch: {
    "searchForm.keyword": {
      handler(val) {
        if (!val) {
          this.layDanhSachCanBoPhanTrang(true);
        }
      }
    }
  }
};
</script>
